/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractInvoicingModeResource } from './';
import {
    ContractInvoicingModeResourceFromJSON,
    ContractInvoicingModeResourceFromJSONTyped,
    ContractInvoicingModeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AppliedContractTermsResourceContractTermsInner
 */
export interface AppliedContractTermsResourceContractTermsInner {
    /**
     * 
     * @type {ContractInvoicingModeResource}
     * @memberof AppliedContractTermsResourceContractTermsInner
     */
    invoicingMode: ContractInvoicingModeResource;
    /**
     * 
     * @type {Date}
     * @memberof AppliedContractTermsResourceContractTermsInner
     */
    freelancerAcceptedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppliedContractTermsResourceContractTermsInner
     */
    clientAcceptedAt?: Date;
}

/**
 * Check if a given object implements the AppliedContractTermsResourceContractTermsInner interface.
 */
export function instanceOfAppliedContractTermsResourceContractTermsInner(value: object): value is AppliedContractTermsResourceContractTermsInner {
    if (!('invoicingMode' in value) || value['invoicingMode'] === undefined) return false;
    if (!('freelancerAcceptedAt' in value) || value['freelancerAcceptedAt'] === undefined) return false;
    return true;
}

export function AppliedContractTermsResourceContractTermsInnerFromJSON(json: any): AppliedContractTermsResourceContractTermsInner {
    return AppliedContractTermsResourceContractTermsInnerFromJSONTyped(json, false);
}

export function AppliedContractTermsResourceContractTermsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppliedContractTermsResourceContractTermsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'invoicingMode': ContractInvoicingModeResourceFromJSON(json['invoicingMode']),
        'freelancerAcceptedAt': (new Date(json['freelancerAcceptedAt'])),
        'clientAcceptedAt': json['clientAcceptedAt'] == null ? undefined : (new Date(json['clientAcceptedAt'])),
    };
}

export function AppliedContractTermsResourceContractTermsInnerToJSON(value?: AppliedContractTermsResourceContractTermsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoicingMode': ContractInvoicingModeResourceToJSON(value['invoicingMode']),
        'freelancerAcceptedAt': ((value['freelancerAcceptedAt']).toISOString()),
        'clientAcceptedAt': value['clientAcceptedAt'] == null ? undefined : ((value['clientAcceptedAt']).toISOString()),
    };
}

